import { RETAILER } from './../../../config';

const SHOPRITE_PRIVACY_POLICY_DATA = [
  { body: [ 'Last update: July 11, 2017' ] },
  {
    header: '',
    body: [
      'Adjoy, Inc. ("us", "we", or "our"), a Delaware corporation, d/b/a ADJOY, operates the Downtime Dollars web application (the "Service").',
      'This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service.',
      'We will not use, collect or share your information with anyone except as described in this Privacy Policy.',
      'We do not need to use your Personal Information for providing the Service, however we may need personal information in order to resolve an issue with or and improve the Service. Any collection or use of your personal information for this purpose will be with your express consent.',
      'By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.',
    ]
  },
  {
    header: 'Information Collection and Use',
    body: [
      'In the process of resolve an issue with or improving the Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to, your name, phone number, email address, or other information ("Personal Information"). We collect this information for the purpose of resolving issues with or improving the Service, identifying and communicating with you, responding to your requests/inquiries and improving our services. If you <a href="mailto:support@getdabbl.com?subject=Shoprite-Privacy-Policy">contact us </a> with an issue regarding your Price Plus® card or ShopRite, we may share any Personal Information you provide with Wakefern Food Corp. ("ShopRite"). We may also collect and share non-Personal Information, such as the overall frequency of customer brand activities, with ShopRite. We may aggregate this information with similar information provided by other users to produce analytics designed to improve the Service’s effectiveness.',
    ]
  },
  {
    header: 'Log Data',
    body: [
      'When you access the Service by or through a mobile device, we may collect certain information automatically, including, but not limited to, the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use and other statistics ("Log Data").',
      "In addition, we may use third party services such as MixPanel or Google Analytics that collect, monitor and analyze this type of information in order to increase our Service's functionality. These third party service providers have their own privacy policies addressing how they use such information.",
    ]
  },
  {
    header: 'Cookies',
    body: [
      'Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and transferred to your device. We use cookies to collect information in order to improve our services for you.',
      'You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. The Help feature on most browsers provides information on how to accept cookies, disable cookies or to notify you when receiving a new cookie.',
      'If you do not accept cookies, you may not be able to use some features of our Service and we recommend that you leave them turned on.',
    ]
  },
  {
    header: 'Do Not Track Disclosure',
    body: [
      'We do not support Do Not Track ("DNT"). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.',
      'You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.',
    ]
  },
  {
    header: 'Service Providers',
    body: [
      'We may employ third-party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Service-related services and/or to assist us in analyzing how our Service is used.',
      'These third parties have access to your Personal Information only to perform specific tasks on our behalf and are obligated not to disclose or use your information for any other purpose.',
    ]
  },
  {
    header: 'Business Transaction',
    body: [
      'If Adjoy, Inc. is involved in a merger, acquisition or asset sale, your Personal Information may be transferred as a business asset. In such cases, we will provide notice before your Personal Information is transferred and/or becomes subject to a different Privacy Policy.',
    ]
  },
  {
    header: 'Security',
    body: [
      'The security of your Personal Information is important to us, and we strive to implement and maintain reasonable, commercially acceptable security procedures and practices appropriate to the nature of the information we store, in order to protect it from unauthorized access, destruction, use, modification, or disclosure.',
      'However, please be aware that no method of transmission over the internet, or method of electronic storage is 100% secure and we are unable to guarantee the absolute security of the Personal Information we have collected from you.',
    ]
  },
  {
    header: 'International Transfer',
    body: [
      'Your information, including Personal Information, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.',
      'If you are located outside United States and choose to provide information to us, please note that we transfer the information, including Personal Information, to United States and process it there.',
      'Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.',
    ]
  },
  {
    header: "Children's Privacy",
    body: [
      'Only persons age 13 or older have permission to access our Service. Our Service does not address anyone under the age of 13 ("Children")  and an app age gate has been added to ensure only persons 13 or older can use our Service.',
      'We do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and you learn that your Children have provided us with Personal Information, please <a href="mailto:support@getdabbl.com?subject=Shoprite-Privacy-Policy">contact us</a>. If we become aware that we have collected Personal Information from a children under age 13 without verification of parental consent, we take steps to remove that information from our servers.',
    ]
  },
  {
    header: 'Changes to this Privacy Policy',
    body: [
      'This Privacy Policy is effective as of July 19, 2016 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.',
      'We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.',
      'If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.',
    ]
  },
  {
    header: 'Contact Us',
    body: [
      'If you have any questions about this Privacy Policy, please <a href="mailto:support@getdabbl.com?subject=Shoprite-Privacy-Policy"> contact us</a>.',
    ]
  },
];

const FRESHGROCER_PRIVACY_POLICY_DATA = [
    { body: [ 'Last update: November 6, 2017' ] },
    {
        header: '',
        body: [
            'Adjoy, Inc. ("us", "we", or "our"), a Delaware corporation, d/b/a ADJOY, operates the Downtime Dollars web application (the "Service").',
            'This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service.',
            'We will not use, collect or share your information with anyone except as described in this Privacy Policy.',
            'We do not need to use your Personal Information for providing the service, however we may need personal information in order to resolve an issue with or improve the Service. Any collection or use of your personal information for this purpose will be with your express consent.',
            'By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.',
        ]
    },
    {
        header: 'Information Collection and Use',
        body: [
            'During app use, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to, your phone number, name, or email ("Personal Information"). We collect this information for the purpose of identifying and communicating with you, including delivery of value earned in app, as well as responding to your requests/inquiries and improving our app services.',
            'We value your This information will not be sold, shared, or used in any way outside of the standard operation of the application.'
        ]
    },
    {
        header: 'Log Data',
        body: [
            'When you access the Service by or through desktop computer, laptop, or a mobile device, we may collect certain information automatically, including, but not limited to, the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of Internet browser you use and other statistics ("Log Data").',
            "In addition, we may use third party services such as Mixpanel that collect, monitor and analyze this type of information in order to increase our Service's functionality. These third party service providers have their own privacy policies addressing how they use such information.",
        ]
    },
    {
        header: 'Cookies',
        body: [
            'Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and transferred to your device. We use cookies to collect information in order to improve our services for you.',
            'You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. The Help feature on most browsers provide information on how to accept cookies, disable cookies or to notify you when receiving a new cookie.',
            'If you do not accept cookies, you may not be able to use some features of our Service and we recommend that you leave them turned on.',
        ]
    },
    {
        header: 'Do Not Track Disclosure',
        body: [
            'We do not support Do Not Track ("DNT"). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.',
            'You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.',
        ]
    },
    {
        header: 'Service Providers',
        body: [
            'We may employ third party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Service-related services and/or to assist us in analyzing how our Service is used.',
            'These third parties have access to your Personal Information only to perform specific tasks on our behalf and are not permitted to disclose or use your information for any other purpose.',
        ]
    },
    {
        header: 'Business Transaction',
        body: [
            'If Adjoy, Inc. is involved in a merger, acquisition or asset sale, your Personal Information may be transferred as a business asset. In such cases, we will provide notice before your Personal Information is transferred and/or becomes subject to a different Privacy Policy.',
        ]
    },
    {
        header: 'Security',
        body: [
            'The security of your Personal Information is important to us, and we strive to implement and maintain reasonable, commercially acceptable security procedures and practices appropriate to the nature of the information we store, in order to protect it from unauthorized access, destruction, use, modification, or disclosure.',
            'However, please be aware that no method of transmission over the internet, or method of electronic storage is 100% secure and we are unable to guarantee the absolute security of the Personal Information we have collected from you.',
        ]
    },
    {
        header: 'International Transfer',
        body: [
            'Your information, including Personal Information, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.',
            'Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.',
        ]
    },
    {
        header: "Children's Privacy",
        body: [
            'Only persons age 13 or older have permission to access our Service. Our Service does not address anyone under the age of 13 ("Children") and an app age gate has been added to ensure only persons 13 or older can use our Service.',
            'We do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and you learn that your Children have provided us with Personal Information, please <a href="mailto:support@getdabbl.com?subject=Fresh-Grocer-Privacy-Policy">contact us</a>. If we become aware that we have collected Personal Information from children under age 13 without verification of parental consent, we take steps to remove that information from our servers.',
        ]
    },
    {
        header: 'Changes to this Privacy Policy',
        body: [
            'This Privacy Policy is effective as of November 6, 2017 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.',
            'We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.',
            'If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.',
        ]
    },
    {
        header: 'Contact Us',
        body: [
            'If you have any questions about this Privacy Policy, please contact us at <a href="mailto:support@getdabbl.com?subject=Fresh-Grocer-Privacy-Policy">support@getdabbl.com</a>.',
        ]
    },
];

const DATA = () => {
    switch (RETAILER){
        case 'freshgrocer':
            return FRESHGROCER_PRIVACY_POLICY_DATA
        case 'shoprite':
            return SHOPRITE_PRIVACY_POLICY_DATA
        default:
            return []
    }
};

export default DATA();



// WEBPACK FOOTER //
// ./src/pages/LegalDocuments/PrivacyPolicy/data.js